export const ALERT_SOUND_REPEAT_COUNT = 9;
export const ALERT_SOUND_REPEAT_INTERVAL_MS = 600;
export const ALERT_SOUND_CHIME_DURATION_MS = 1400;

// A new alert that arrives while a burst is still audible is absorbed by it, so the throttle window
// runs until the last repeat's chime has finished.
export const ALERT_SOUND_THROTTLE_MS =
  (ALERT_SOUND_REPEAT_COUNT - 1) * ALERT_SOUND_REPEAT_INTERVAL_MS + ALERT_SOUND_CHIME_DURATION_MS;

export const ALERT_SOUND_STORAGE_KEY = 'app-alert-sound';
